import styled from 'styled-components';

export default styled.div`
	width: 100%;
	max-width: 1200px;
	padding: 0 2.5rem;
	margin: 0 auto;
	@media all and (max-width: 500px) {
		padding: 0 1rem;
	}
`;
